import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from './config-initialization.service';

@Injectable({
  providedIn: 'root'
})
export class ConsoleToggleService {

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
  ) {}

  disableConsoleInProduction(): void {
    if (this.config.production) {
      console.warn = function (): void { };
      console.log = function (): void { };
      console.debug = function (): void { };
      console.warn = function (): void { };
      console.info = function (): void { };
    }
  }
}